import type { CertificateDetails } from "../_model";
import { t } from "../i18n";
import { locale } from "../../SHARED/i18n";
import { Show } from "solid-js";
// import Wallet from "../assets/wallet.svg";
// import { createMemo } from "solid-js";

function downloadURI(uri: unknown, _fileName: string) {
	if (uri == null || typeof uri !== "string") {
		console.log("download-error: uri must be defined and of type string!!");
		return;
	}
	const fileName = uri.substring(uri.lastIndexOf("/") + 1);
	const fileUrl = uri;
	// https://thingproxy.freeboard.io/ | https://corsproxy.io/ | https://cors-anywhere.herokuapp.com/
	const proxyUrl = "https://corsproxy.io/?url=" + encodeURIComponent(fileUrl);
	// const proxyUrl = fileUrl;

	fetch(proxyUrl)
		.then((response) => response.blob())
		.then((blob) => {
			const link = document.createElement("a");
			link.href = URL.createObjectURL(blob);
			link.download = fileName;
			link.target = "_blank";
			link.rel = "noreferrer noopener";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		})
		.catch((error) => {
			console.error("Error downloading the file:", error);
		});
}

function isNull(value: undefined | boolean | string) {
	if (value == undefined) {
		return true;
	}
	if (typeof value === "boolean") {
		return true;
	}
	return false;
}

export default function (props: { details: CertificateDetails }) {
	const show_attendance = !isNull(props.details.attendance);
	const show_top10 = !isNull(props.details.top_10);
	const show_top3 = !isNull(props.details.top_3);
	const show_guinness = !isNull(props.details.guinness);
	return (
		<section class="flex flex-col w-full h-full pt-10 pb-2 gap-4 overflow-y-auto">
			<p class="flex flex-col gap-0.5 font-600 text-35px">
				<span>{t().welcome.start}</span>
				<span class="capitalize">
					{locale() === "en" ? props?.details.name_en : props?.details.name_ar}
				</span>
				<span>{t().welcome.end}</span>
			</p>
			{/* attendace */}
			<Show when={show_attendance}>
				<div class="flex flex-col gap-2">
					<p class="flex flex-row gap-2 text-20px items-center justify-start font-600 gap-2 capitalize">
						<span class="i-fluent:certificate-16-filled w-24px h-24px text-error" />
						<span>{t().attendance.label}:</span>
					</p>
					<div class="flex flex-col gap-2">
						<DownloadButton
							label={t().attendance.button}
							icon="i-basil:document-solid"
							link={props.details?.attendance}
						/>
						{/* <span class="text-text-alt text-14px">{t().caution}</span> */}
					</div>
				</div>
			</Show>
			{/* top 10 */}
			<Show when={show_top10}>
				<div class="flex flex-col gap-2">
					<p class="flex flex-row gap-2 text-20px items-center justify-start font-600 gap-2 capitalize">
						<span class="i-fluent:certificate-16-filled w-24px h-24px text-error" />
						<span>{t().top10.label}:</span>
					</p>
					<div class="flex flex-col gap-2">
						<DownloadButton
							label={t().top10.button}
							icon="i-basil:document-solid"
							link={props.details?.top_10}
						/>
						{/* <span class="text-text-alt text-14px">{t().caution}</span> */}
					</div>
				</div>
			</Show>
			{/* top 3 */}
			<Show when={show_top3}>
				<div class="flex flex-col gap-2">
					<p class="flex flex-row gap-2 text-20px items-center justify-start font-600 gap-2 capitalize">
						<span class="i-fluent:certificate-16-filled w-24px h-24px text-error" />
						<span>{t().top3.label}:</span>
					</p>
					<div class="flex flex-col gap-2">
						<DownloadButton
							label={t().top3.button}
							icon="i-basil:document-solid"
							link={props.details?.top_3}
						/>
						{/* <span class="text-text-alt text-14px">{t().caution}</span> */}
					</div>
				</div>
			</Show>
			{/* guiness */}
			<Show when={show_guinness}>
				<div class="flex flex-col gap-2">
					<p class="flex flex-row gap-2 text-20px items-center justify-start font-600 gap-2 capitalize">
						<span class="i-fluent:certificate-16-filled w-24px h-24px text-error" />
						<span>{t().guinness.label}:</span>
					</p>
					<div class="flex flex-col gap-2">
						<DownloadButton
							label={t().guinness.button}
							icon="i-basil:document-solid"
							link={props.details?.guinness}
						/>
						{/* <span class="text-text-alt text-14px">{t().caution}</span> */}
					</div>
				</div>
			</Show>
			<span class="text-text-alt text-14px">{t().caution}</span>
		</section>
	);
}

function DownloadButton(props: {
	label: string | JSX.Element;
	icon: string | JSX.Element;
	link: string | boolean;
	class?: string;
	name?: string;
}) {
	return (
		<p
			class={
				(props.class ?? "") +
				" " +
				"flex flex-row w-fit h-fit gap-2 items-center justify-between capitalize text-16px py-2 px-2 border-text-alt border-solid border-2 rounded-md cursor-pointer <sm:(!w-full)" +
				" " +
				(props.link == undefined ? "cursor-not-allowed opacity-50" : "")
			}
			onclick={() => downloadURI(props.link, props.name)}
		>
			{typeof props.icon === "string" ? (
				<span class={(props.icon ?? "") + " w-24px h-24px text-text-alt"} />
			) : (
				props.icon
			)}
			{typeof props.label === "string" ? (
				<span>{props.label}</span>
			) : (
				props.label
			)}
			<span class="i-line-md:download-loop w-24px h-24px text-text-alt" />
		</p>
	);
}
